import { Breadcrumb } from '@/components/Atoms/Breadcrumbs'
import { HasFeature } from '@/components/Atoms/Permissions'
import { CompaniesFeature } from '@/lib/features/companies'
import { buildPath } from '@/routes'
import { Navigate, Outlet } from 'react-router'

export function VinLookupLayout() {
  return (
    <HasFeature
      feature={CompaniesFeature.VinLookup}
      noFeatureComponent={<Navigate to={buildPath('/companies')} />}
    >
      <div className="flex flex-col gap-4">
        <Breadcrumb
          label="VIN Lookup"
          path={buildPath('/companies/vin-lookup')}
        />
        <Outlet />
      </div>
    </HasFeature>
  )
}
